import { FontSizes, IStyle, Label, PrimaryButton, Stack, Text, useTheme } from '@fluentui/react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { IEvent } from '../../../../Models/Event/IEvent';
import { backendUrl } from '../../../../Services/ConfigureService';
import { PageTitle } from '../../../PageTitle';
import {dateToCZTimeStr} from "../../../../Tools/DateTime";

interface IEventDetailViewProps {
    event: IEvent;
    smallScreen: boolean
}

const labelStyle = {
    root: {
        padding: 10,
        color: "gray",
        fontSize: 14,
        minWidth:120
    }
}

const textStyle = {
    root: {
        padding: 10,
        color: "black",
        fontSize: 16,
        maxWidth: 600,
        owerflow:"hidden"
    }
}
const dayOfWeek = ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota", "Neděle"];

export const EventDetailView: React.FunctionComponent<IEventDetailViewProps> = (props) => {

    const theme = useTheme();
    const navigate = useNavigate();

    const renderButtom = (item: IEvent) => {

        let registrationDate = new Date(item.registrationStart);
        registrationDate.setHours((item.registrationTime as Date).getHours());
        registrationDate.setMinutes((item.registrationTime as Date).getMinutes());

        if (registrationDate > new Date(Date.now())) {
            if (registrationDate.getDate() === new Date(Date.now()).getDate()) {
                return <Stack horizontalAlign="center" wrap styles={{ root: { color: theme.palette.green } }}>registrace dnes v <span>{dateToCZTimeStr(registrationDate)}</span></Stack>
            } else {
                return <Stack horizontalAlign="center" wrap styles={{ root: { color: theme.palette.green } }}>registrace od <span>{registrationDate.toLocaleDateString("cs-CZ")}</span><span>v {dateToCZTimeStr(registrationDate)}</span></Stack>
            }
        }
        if ((item.seets - item.seetsTaken) > 4) {
            return <Stack horizontalAlign="center"><PrimaryButton text="Objednat" styles={{ root: { width: 200 } }} onClick={() => { navigate(`/events/order?eventId=${item.id}`) }} /></Stack>
        }
        var desc = null;
        if (((item.seets - item.seetsTaken) <= 4) && (item.seets - item.seetsTaken) > 0) {
            return <>
                <Stack horizontalAlign="center"><PrimaryButton text="Objednat" styles={{ root: { width: 200 } }} onClick={() => { navigate(`/events/order?eventId=${item.id}`) }} /></Stack>
                <Stack horizontalAlign="center" styles={{ root: { color: theme.palette.red } }}>poslední {(item.seets - item.seetsTaken)} místa</Stack>
            </>
        }

        if ((item.seets - item.seetsTaken) <= 0 && (item.substitutes - item.substitutesTaken) > 0) {
            return <>
                <Stack horizontalAlign="center"><PrimaryButton text="Objednat" styles={{ root: { width: 200 } }} onClick={() => { navigate(`/events/order?eventId=${item.id}`) }} /></Stack>
                <Stack horizontalAlign="center" styles={{ root: { color: theme.palette.red } }}>jako náhradník</Stack>
            </>
        }
        else
        {
            return <Stack horizontalAlign="center"><PrimaryButton disabled text="Obsazeno" styles={{ root: { width: 200 } }} /></Stack>
        }
    }


    return (
        <Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
            <PageTitle title={props.event.name} />
            <Stack horizontalAlign="center" styles={{ root: { paddingTop: 40 } }} >
                
                <Stack horizontalAlign="center"
                    styles={{
                        root: {                            
                            position: 'relative', boxShadow: '2px 2px 10px  lightgray',
                            padding: props.smallScreen ? 15 : 40,
                            paddingLeft: props.smallScreen ? 5 : 40,
                            paddingRight: props.smallScreen ? 5 : 40, display: 'block', width: '100%', maxWidth:800,  borderColor: 'white', borderWidth: 1, borderRadius: 10, borderStyle: 'solid'
                        }
                    }}>
                    <Stack wrap horizontal>
                        <Stack horizontalAlign="center" verticalAlign="center" styles={{
                            root: {
                                paddingRight: 15,
                                paddingLeft: 15,
                                paddingBottom: 15,
                            }
                        }} >
                            <img src={backendUrl() + `api/Event/GetProfileImage/${props.event.id}`} style={{ maxWidth: 200 }} onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = "/img/noimageicon.png";
                            }} />

                            
                            
                        </Stack>
                        <Stack grow styles={{ root: { maxWidth:500 } }}>
                            <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                     Událost
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                     {props.event.name} 
                                </Stack.Item>
                            </Stack>
                            <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                    Lektor
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                    {props.event.teacher}
                                </Stack.Item>
                            </Stack>

                                <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                    Den a čas konání
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                    {dayOfWeek[props.event.dayOfWeek]+ " v " + props.event.time}
                                </Stack.Item>
                            </Stack>
                            <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                    Místo konání
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                    {props.event.roomName + ", " + props.event.roomDistrict}
                                </Stack.Item>
                            </Stack>
                            <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                    Věková skupina
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                    {props.event.ageGroupName}
                                </Stack.Item>
                            </Stack>
                            <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                   Datum zahájení
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                    {(props.event.dateOfFirstLesson as Date).toLocaleDateString("cs-CZ")}
                                </Stack.Item>
                            </Stack>
                            <Stack horizontal verticalAlign="center">
                                <Stack.Item styles={labelStyle}>
                                    Počet lekcí
                                </Stack.Item>
                                <Stack.Item grow styles={textStyle}>
                                    {props.event.numberOfLessons}
                                </Stack.Item>
                            </Stack>
                          </Stack>
                    </Stack>
                    <Stack horizontalAlign="center" styles={{ root: { paddingTop:40 } }}>
                        {renderButtom(props.event)}
                    </Stack>
                    </Stack>
                 </Stack>                
        </Stack>
 
    )
}